import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-email-confirmation',
  templateUrl: './TextDialogue.component.html',
  styleUrls: ['./TextDialogue.component.css']
})

export class TextDialogueComponent implements OnInit {
  DialogueData: any;

  constructor(
    public dialogRef: MatDialogRef<TextDialogueComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {    
    this.DialogueData = this.data;
  }



  closeDialog(): void {
    $(".body").css("filter", "blur(0px)");
    this.dialogRef.close();
  }
}
